<template>
  <div>
    <div
      v-if="data.displayName"
      style="
        font-style: normal;
        font-weight: 600;
        line-height: normal;
      "
      :style="{ fontSize: useFontSizeScale(22).value }"
    >
      <span>{{ data.displayName }}</span>
    </div>

    <!-- Profession label -->
    <div
      v-if="data.profession"
      :style="{
        'background-color': data.theme?.background,
        color: data.theme?.text,
      }"
      style="
        width: fit-content;
        border-radius: 6px;
        padding: 2px 8px;
        padding: 6px 8px;
        margin-top: 8px;
        word-break: break-all;
      "
    >
      <span
        style="font-style: normal; font-weight: 400; line-height: normal;"
        :style="{ fontSize: useFontSizeScale(12).value }"
      >
        {{ data.profession }}
      </span>
    </div>

    <table role="presentation" cellpadding="0" cellspacing="0" border="0" style="border-collapse: collapse;" :style="{ 'font-family': data.font }">
      <tbody>
        <tr>
          <!-- Icon + Text -->
          <td style="padding-top: 8px;">
            <table role="presentation" cellpadding="0" cellspacing="0" border="0" style="border-collapse: collapse;">
              <tbody>
                <tr v-for="row of dataRows" :key="row[0].field">
                  <td v-for="{ field, value } of row" :key="field" style="padding: 4px;">
                    <table role="presentation" cellpadding="0" cellspacing="0" border="0" style="border-collapse: collapse;">
                      <tbody>
                        <tr>
                          <td v-if="value">
                            <div
                              :style="{ backgroundColor: data.theme?.background || 'black' }"
                              style="height: 24px; width: 24px; border-radius: 50%; text-align: center; place-content: center;"
                            >
                              <img
                                :src="data[`${field}IconUrl`]"
                                :alt="altTexts[field]"
                                width="12" height="12"
                                style="vertical-align: middle; display: inline-block; height: 12px; width: 12px;"
                              />
                            </div>
                          </td>
                          <td
                            v-if="value"
                            style="padding-left: 4px; overflow-wrap: anywhere; word-break: break-all;"
                            :style="{ fontSize: useFontSizeScale(14).value }"
                          >
                            <template v-if="['website','email','telephoneNumber','mobileNumber'].includes(field)">
                              <a
                                :href="
                                  field === 'website' ? (value.startsWith('http') ? value : 'https://' + value)
                                  : field === 'email' ? 'mailto:' + value
                                  : (field === 'telephoneNumber' || field === 'mobileNumber') ? 'tel:' + value
                                  : ''
                                "
                                target="_blank"
                                style="color: inherit; text-decoration: none;"
                              >{{ value }}</a>
                            </template>
                            <template v-else>{{ value }}</template>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </td>

          <!-- Image -->
          <td style="padding-top: 8px; padding-left: 12px;">
            <img
              v-if="data.imageUrl"
              :src="data.imageUrl"
              alt=""
              style="
                margin-left: 12px;
              "
              :style="{
                display: 'block',
                maxWidth: '90px',
                maxHeight: '90px',
                borderRadius: '16px',
                width: 'auto',
                height: 'auto'
              }"
          />
          </td>
        </tr>
      </tbody>
    </table>

    <!-- Disclaimer -->
    <div
      v-if="data.disclaimer"
      style="
        border-top: 1px solid #E8E6E3;
        margin-top: 16px;
        padding-top: 8px;
        color: #707070;
      "
      :style="{ fontSize: useFontSizeScale(11).value }"
    >{{ data.disclaimer }}</div>
  </div>
</template>

<script setup>
import { useFontSizeScale } from '@/io.ox/mail/settings/signatures/signature-designer/composables/useFontSizeScale'
import { computed } from 'vue'
import gt from 'gettext'

const availableFields = [
  'displayName',
  'profession',
  'telephoneNumber',
  'mobileNumber',
  'website',
  'imageUrl',
  'disclaimer',
  'theme',
  'email',
  'font',
  'fontSize'
]

const dataMap = computed(() => {
  return Object.entries({
    telephoneNumber: data.telephoneNumber,
    email: data.email,
    mobileNumber: data.mobileNumber,
    website: data.website
  })
    .map(([field, value]) => ({ field, value }))
    .filter(pair => pair.value !== '')
})

const altTexts = {
  telephoneNumber: gt('Phone'),
  email: gt('Email address'),
  mobileNumber: gt('Cell phone'),
  website: gt('Website')
}

const dataRows = computed(() => {
  const rows = []
  for (let i = 0; i < dataMap.value.length; i += 2) {
    rows.push(dataMap.value.slice(i, i + 2))
  }
  return rows
})

const { data } = defineProps({
  data: { type: Object, required: true }
})

defineExpose({
  availableFields,
  imageSlots: [
    { field: 'imageUrl', aspect: 'square' }
  ],
  previewTheme: { id: 'black', background: '#000000', text: 'white' }
})
</script>
